import React from "react";

import { Modal } from "../Modal";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";
import { deleteIntegrationsMappings } from "../../services/IntegrationApi";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useIntegrationContext } from "./IntegrationProvider";
import { Button } from "../../UI/Button";
import { extractErrorMessage } from "../../helpers/extractErrorMessage";
import { Typography } from "../../UI/Typography";
import { Box } from "../../UI/Box";

interface IProps {
  id: number;
}

export const IntegrationDeleteModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { getAuthToken } = useAuth();
  const { loadIntegrations } = useIntegrationContext();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClose = () => setIsOpen(false);



  const handleDelete = async () => {
    setIsLoading(true);
    const res = await deleteIntegrationsMappings(selectedNetworkId, props.id, await getAuthToken());

    if (res && res.ok) {
      await loadIntegrations(selectedNetworkId);
      showSuccessSnackbar("Saved Changes");
      handleClose();
    } else {
      const errorMessage = extractErrorMessage(res);
      showErrorSnackbar(errorMessage);
    }

    setIsLoading(false);
  };

  return (
    <Modal
      maxWidth="xs"
      title="Delete Mapping"
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button appearance="danger" onClick={handleDelete} isLoading={isLoading}>
            Delete Mapping
          </Button>
        </>
      }
    >
      <Box p={3}>
        <Typography paragraph>You are about to delete a integration mapping.</Typography>
      </Box>
    </Modal>
  );
};
